import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import { FuncionarioFormProps, FuncionarioFormData } from '../../types';
import './FuncionarioForm.css';

const FuncionarioForm: React.FC<FuncionarioFormProps> = ({ 
  show, 
  onHide, 
  onSave, 
  funcionario 
}) => {
  const [formData, setFormData] = useState<FuncionarioFormData>({
    nome: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (funcionario) {
      setFormData({
        nome: funcionario.nome
      });
    } else {
      setFormData({
        nome: ''
      });
    }
    setError('');
  }, [funcionario, show]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.nome.trim()) {
      setError('Nome é obrigatório');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await onSave(formData);
    } catch (err) {
      setError('Erro ao salvar funcionário');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({ nome: '' });
    setError('');
    onHide();
  };

  return (
    <Modal 
      show={show} 
      onHide={handleClose} 
      centered
      size="lg"
      dialogClassName="funcionario-modal-dialog"
      contentClassName="funcionario-modal-content"
    >
      
      <Modal.Header closeButton className="funcionario-modal-header">
        <Modal.Title className="funcionario-modal-title">
          {funcionario ? 'Editar Funcionário' : 'Novo Funcionário'}
        </Modal.Title>
      </Modal.Header>
      
      <Form onSubmit={handleSubmit}>
        <Modal.Body className="funcionario-modal-body">
          {error && (
            <Alert variant="danger" className="mb-3 funcionario-modal-alert">
              {error}
            </Alert>
          )}

          <Form.Group className="mb-4">
            <Form.Label className="funcionario-modal-label">Nome do Funcionário *</Form.Label>
            <Form.Control
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              placeholder="Digite o nome completo do funcionário"
              required
              disabled={loading}
              className="funcionario-modal-input"
              size="lg"
            />
            <Form.Text className="text-muted funcionario-modal-help">
              Um código de acesso único será gerado automaticamente após salvar.
            </Form.Text>
          </Form.Group>

          {funcionario && (
            <Form.Group className="mb-4">
              <Form.Label className="funcionario-modal-label">Código de Acesso</Form.Label>
              <Form.Control
                type="text"
                value={funcionario.codigo}
                disabled
                className="bg-light funcionario-modal-input"
                size="lg"
              />
              <Form.Text className="text-muted funcionario-modal-help">
                Este é o código que o funcionário usará para fazer login.
              </Form.Text>
            </Form.Group>
          )}
        </Modal.Body>

        <Modal.Footer className="funcionario-modal-footer">
          <Button 
            variant="secondary" 
            onClick={handleClose}
            disabled={loading}
            className="funcionario-modal-btn-cancel"
            size="lg"
          >
            Cancelar
          </Button>
          <Button 
            variant="primary" 
            type="submit"
            disabled={loading || !formData.nome.trim()}
            className="funcionario-modal-btn-save"
            size="lg"
          >
            {loading ? 'Salvando...' : (funcionario ? 'Atualizar' : 'Criar Funcionário')}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default FuncionarioForm;
